<template>
<div class="card">
    <div class="card-header">
        <p class="card-header-title">Import Students from excel (xlsx)</p>
    </div>
    <div class="card-content">
        <div class="content">            
            <loading :active.sync="isLoading" 
                :can-cancel="false" 
                :is-full-page="true">
            </loading>                           
            <b-field class="file">                      
                <b-upload v-model="file">
                    <a class="button is-primary">
                        <font-awesome-icon icon="file-upload" /> 
                        <span>&nbsp;Import students from excel</span>
                    </a>
                </b-upload>
                <span class="file-name" v-if="file && file">{{ file.name }}</span>
                <b-select placeholder="Import option" id="option1"  v-model="input.option1">
                    <option value="1">Add only new students</option>
                    <option value="2">Overwrite all students in this group</option>
                </b-select>
                <button class='button is-info' v-on:click="uploadExcel()">
                    Upload now
                </button>
            </b-field>
            <p>Note: Before you upload your excel file, make sure that your excel file follows exactly the same structure as the template which you can download below.</p>
            <a class="button is-small is-warning" v-on:click="downloadTemplate()">Download Excel (xlsx) template</a>                       
        </div>
    </div>
</div>


</template>

<script>
import axios from 'axios'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    props: ['kelasID'],
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            input: {
                groupID: '',
                option1: 1,
            },
            kelasList: [],
            result: "",
            file: null
        };
    },
    beforeMount() {
        this.openForm()
    },
    created() {
    },
    methods: {
        openForm() {
            this.input.isCreating = true;
        },
        closeForm() {
            this.input.isCreating = false;
        },        
        uploadExcel(){
            console.log("Entering uploadExcel")
            this.groupID = this.$parent.groupID;
            console.log(this.groupID)
            console.log(this.file)
            console.log("option1")
            console.log(this.input.option1)

            if (this.file != null){
            
                if (this.input.option1 == 2){
                    this.$swal({
                        title: "Are you sure?",
                        text: "All students in this group will be removed and replaced with the students from inside the selected excel file.",
                        showCancelButton: true,
                        confirmButtonText: 'Yes, proceed',
                        cancelButtonText: 'No, cancel',
                        showCloseButton: true
                    }).then((result) => {
                        if (result.value){
                            this.importStudentsFromExcel(this.groupID,this.file,this.input.option1)
                        }
                    });
                }else{
                    this.importStudentsFromExcel(this.groupID,this.file,this.input.option1)
                }

            }else{
                alert("Please select the excel file you want to upload.")
                return false;
            }
            
        },
        downloadTemplate(){
            var downloadLink = "http://" + window.location.hostname + "/downloads/template_import_students_into_group.xlsx";
            window.open(downloadLink,"_blank")
        },
        importStudentsFromExcel(groupID,file,option1){
            console.log("groupID: " + groupID + " file: " + file + " option1: " + option1)
            this.isLoading = true;

            if (this.file != null){
                this.isLoading = true;

                let formData = new FormData();                
                formData.append('email', localStorage.getItem('email'));
                formData.append('file', this.file);
                formData.append('groupID', groupID);
                formData.append('option1', option1);

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.post(process.env.MY_URL + '/api/group/import',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(response => {
                    console.log('SUCCESS!!');
                    console.log(response)
                    if (response.data.success == true) {
                        console.log("Students imported!")
                        this.file = null
                        this.isLoading = false
                        
                        Toast.open({
                            color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            message: response.data.msg,
                            type: 'is-success',
                            duration: 3000
                        })
                            
                        this.$parent.getStudents()
                    } else {
                        Toast.open({
                            message: response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                        this.isLoading = false
                        console.log(response.data.msg)
                    }
                })
                .catch(e => {
                    console.log(e.response)
                    Toast.open({
                        message: e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    this.isLoading = false
                });

            }else{
                alert("Please select the excel file you want to upload.")
                return false;
            }
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Database/Group/ImportStudents.vue